import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";

// List of catalog names to fetch
const CATALOG_NAMES = [
  "alimentosBebidas",
  "instalaciones",
  "areasAdicionales",
  "estacionamiento",
  "servicios",
  "politicaPagos",
  "capacityFields",
  "documentos",
  "transporteTerrestre",
  "basicInfo",
];

// Fetch all catalogs from Firestore.
// Items without `orden` are sorted to the end so legacy data keeps loading.
export async function loadAllCatalogs() {
  const catalogs = {};
  for (const name of CATALOG_NAMES) {
    const items = [];
    const itemsColl = collection(db, "catalogos", name, "items");
    const snapshot = await getDocs(itemsColl);
    snapshot.forEach((doc) => {
      items.push({ id: doc.id, ...doc.data() });
    });
    items.sort((a, b) => {
      const ao = typeof a.orden === "number" ? a.orden : Number.POSITIVE_INFINITY;
      const bo = typeof b.orden === "number" ? b.orden : Number.POSITIVE_INFINITY;
      return ao - bo;
    });
    catalogs[name] = items;
  }
  return catalogs;
}

// Fetch the two proveedor catalogs (categorias + subcategorias) ordered by `orden`.
// Kept separate from loadAllCatalogs to avoid pulling unrelated catalogs in proveedor screens.
export async function loadProveedorCatalogs() {
  const fetchOrdered = async (name) => {
    const itemsColl = collection(db, "catalogos", name, "items");
    const snap = await getDocs(query(itemsColl, orderBy("orden")));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  };
  const [categorias, subcategorias] = await Promise.all([
    fetchOrdered("proveedorCategorias"),
    fetchOrdered("proveedorSubcategorias"),
  ]);
  return { categorias, subcategorias };
}
